/* Brian Gomitas — interacciones mínimas */
(function () {
  // Menú móvil
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Formato de precio
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP';
    var digits = cur === 'COP' || cur === 'CLP' ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(digits); }
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    // Cantidad
    var qty = form.querySelector('.qty__input');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Variantes
    var dataEl = form.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceEls = document.querySelectorAll('[data-price]');
    var fieldsets = form.querySelectorAll('.opts');
    var labels = { add: addLabel ? addLabel.textContent : '', sold: 'Agotado' };

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { if (addBtn) addBtn.disabled = true; return; }
      idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? labels.add : labels.sold; }
      priceEls.forEach(function (p) {
        var now = p.querySelector('.price__now'); if (now) now.textContent = money(v.price);
        var was = p.querySelector('.price__was');
        if (was) { if (v.compare_at_price > v.price) { was.hidden = false; was.lastChild.textContent = money(v.compare_at_price); } else { was.hidden = true; } }
        var badge = p.querySelector('.price__badge');
        if (badge) { if (v.compare_at_price > v.price) { badge.hidden = false; badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; } else { badge.hidden = true; } }
      });
      if (history.replaceState && document.body.classList.contains('template-product')) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  });

  // Galería
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        slides.forEach(function (s, k) { s.hidden = k !== i; });
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Barra de compra fija en móvil
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainForm = document.querySelector('.product-main [data-product-form]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    sticky.style.transform = 'translateY(110%)';
    sticky.style.transition = 'transform .25s';
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      sticky.style.transform = (!e.isIntersecting && below) ? 'none' : 'translateY(110%)';
    }).observe(mainForm);
    sticky.querySelector('[data-sticky-buy-btn]').addEventListener('click', function () {
      mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();

/* Testimonios en video: uno a la vez, con sonido */
(function () {
  document.querySelectorAll('[data-vtest]').forEach(function (sec) {
    var rail = sec.querySelector('[data-vt-rail]');
    var cards = sec.querySelectorAll('.vcard');
    function stopAll(except) {
      cards.forEach(function (c) {
        var v = c.querySelector('video');
        if (v && c !== except) { v.pause(); v.controls = false; c.classList.remove('is-playing'); }
      });
    }
    cards.forEach(function (card) {
      var btn = card.querySelector('[data-vt-play]');
      var v = card.querySelector('video');
      if (!btn || !v) return;
      btn.addEventListener('click', function () {
        stopAll(card);
        v.muted = false; v.controls = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        card.classList.add('is-playing');
      });
      v.addEventListener('pause', function () { if (v.ended || v.paused) card.classList.remove('is-playing'); v.controls = false; });
      v.addEventListener('play', function () { card.classList.add('is-playing'); });
    });
    var step = function () { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 300; };
    var prev = sec.querySelector('[data-vt-prev]'), next = sec.querySelector('[data-vt-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) stopAll(null); }); }, { threshold: 0 }).observe(sec);
    }
  });
})();

/* Videos de presentaciones: se reproducen solo cuando están en pantalla */
(function () {
  var vids = document.querySelectorAll('video[data-autoplay-view]');
  if (!vids.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else { v.pause(); }
    });
  }, { threshold: 0.35 });
  vids.forEach(function (v) { v.muted = true; io.observe(v); });
})();

